import $ from "jquery";

import ComponentInitializers from 'components/shared/ComponentInitializers/ComponentInitializers';
const Tmpl = require('blueimp-tmpl');

export default class CommentReply {
  constructor(){
    this.replySelector = ".comments__actions-reply";
    this.replyCommentTemplateSelector = "comment-reply-form";
    this.replyCommentButtonSelector = ".comments__reply-submit-button";
    this.replyCommentCancelSelector = ".comments__reply-cancel-button";
    this.replyCommentContainerSelector = ".comments__actions-container";
    this.form = "#new_comment";
  }

  init() {
    this.bindReplyLinkClick();
  }

  bindReplyLinkClick() {
    $(document).on('click', this.replySelector, function(e){
      e.preventDefault();
      this.getReplyCommentTemplate(e.target);
      this.bindRequireLoginModal();
    }.bind(this));
  }

  bindRequireLoginModal(){
    new ComponentInitializers();
  }

  bindCancelButton() {
    $(this.replyCommentCancelSelector).on("click", function(e){
      e.preventDefault();
      $(e.target).closest('.comments__actions-container').empty();
    });
  }

  getReplyCommentTemplate(target) {
    $('.comments__actions-container').empty();
    var dataId = $(target).data("id");
    var mentionUserId = $(target).data('mentionUserId');
    var mentionUserName = $(target).data('mentionUserName');
    var mention = null;

    if (mentionUserId) {
      mention  = { id: mentionUserId, name: mentionUserName };
    }

    var tmplSelector = Tmpl(this.replyCommentTemplateSelector, { id: dataId, mention: mention });
    var template = $(tmplSelector);

    $(target).siblings(this.replyCommentContainerSelector).html(template.html());
    $(target).siblings(this.replyCommentContainerSelector).find('textarea').addClass("spec__comments__textarea-focus").focus();
    this.bindCancelButton(target);
    this.bindReplyButtonClick(target);

    if(mentionUserId) {
      var paddingLeft = $('#mention-' + mentionUserId).width() + 15;
      $('#mention-' + mentionUserId + ' + .comments__textarea').css('padding-left', paddingLeft + 'px');
    }
  }

  bindReplyButtonClick(target) {
    $(document).on("ajax:success", '#new_comment', function(){
      $(target).siblings(this.replyCommentContainerSelector).html('');
    }.bind(this));
  }
}
